import { useEffect, useState } from 'react';

export const useFiltersPosition = () => {
  const [stickyTop, setStickyTop] = useState(0);
  const calcTopPosition = () => {
    const headerHeight =
      // TODO: refactor without type assertion, or add comment
      // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
      (document.querySelectorAll('header.page-header')?.[0] as HTMLElement)
        ?.offsetHeight;
    if (stickyTop !== headerHeight) {
      setStickyTop(headerHeight);
    }
  };

  useEffect(() => {
    calcTopPosition();
    window.addEventListener('scroll', calcTopPosition);
    return () => {
      window.removeEventListener('scroll', calcTopPosition);
    };
  }, [stickyTop]);

  return {
    stickyTop,
  };
};
